exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-information>.booking-confirmation .main-message[data-v-0c8e1e14]{color:red}.travel-ideas .idea-title .index[data-v-0c8e1e14]{background:red}.booking-information>.booking-confirmation>.icon[data-v-0c8e1e14]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c8e1e14","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/abort/Abort.vue
// module id = 624
// module chunks = 0